import { Link } from 'react-router-dom';
import { HiOutlineMail, HiOutlinePhone, HiOutlineBriefcase, HiOutlineSparkles } from 'react-icons/hi';
import { FaWhatsapp } from 'react-icons/fa';
import SEO from '../components/SEO';

const TIMELINE = [
  {
    title: 'Diploma in Physiotherapy',
    meta: 'Graduated December 2025',
    description: 'Trained in patient assessment, treatment planning, and rehabilitation care.',
  },
  {
    title: 'Digital Marketer',
    meta: 'Ongoing',
    description: 'Running SEO, email marketing, and search ad campaigns to grow online visibility.',
  },
  {
    title: 'Academic Writer & Blogger',
    meta: 'Ongoing',
    description: 'Producing well-researched academic content and engaging, easy-to-read blog posts.',
  },
];

const SKILLS = [
  { group: 'Healthcare', items: ['Physiotherapy', 'Patient Assessment', 'Rehabilitation Care'] },
  { group: 'Digital Marketing', items: ['SEO & Analytics', 'Email Marketing', 'Search Ads'] },
  { group: 'Content', items: ['Academic Writing', 'Blogging'] },
];

export default function Resume() {
  return (
    <div className="page container">
      <SEO
        title="Resume | Joan Christine Nyawira — Physiotherapist, Digital Marketer, Writer"
        description="Diploma in Physiotherapy, hands-on digital marketing experience in SEO and search ads, and academic writing — the résumé of Joan Christine Nyawira."
        path="/resume"
      />
      <div className="glass-card resume-header">
        <div>
          <h1>Resume</h1>
          <p className="resume-tagline">Physiotherapist · Digital Marketer · Academic Writer</p>
          <p className="resume-summary">
            Passionate about healing, creativity, and growth — blending hands-on patient care with
            data-driven digital marketing and thoughtful writing.
          </p>
        </div>
        <div className="resume-contact-row">
          <a className="resume-contact-item" href="mailto:muriithijoanchristine@gmail.com">
            <HiOutlineMail /> Email
          </a>
          <a className="resume-contact-item" href="tel:0702405954">
            <HiOutlinePhone /> Call
          </a>
          <a
            className="resume-contact-item"
            href="https://wa.me/254702405954?text=Hello%20Jowey%2C%20the%20website%20sent%20me%20here%F0%9F%98%8A"
            target="_blank"
            rel="noreferrer"
          >
            <FaWhatsapp /> WhatsApp
          </a>
        </div>
      </div>

      <div className="resume-grid">
        <section className="glass-card resume-panel">
          <h2 className="resume-panel-title"><HiOutlineBriefcase /> Education &amp; Experience</h2>
          <div className="timeline">
            {TIMELINE.map(({ title, meta, description }) => (
              <div className="timeline-item" key={title}>
                <span className="timeline-dot" />
                <div className="timeline-content">
                  <div className="timeline-title-row">
                    <h3>{title}</h3>
                    <span className="timeline-meta">{meta}</span>
                  </div>
                  <p>{description}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="glass-card resume-panel">
          <h2 className="resume-panel-title"><HiOutlineSparkles /> Skills</h2>
          {SKILLS.map(({ group, items }) => (
            <div className="skill-group" key={group}>
              <h3 className="skill-group-title">{group}</h3>
              <div className="skill-tags">
                {items.map((item) => (
                  <span className="skill-tag" key={item}>{item}</span>
                ))}
              </div>
            </div>
          ))}
        </section>
      </div>

      <div className="glass-card resume-cta">
        <div>
          <h2>Let's work together</h2>
          <p>Have a project or role in mind? I'd love to hear from you.</p>
        </div>
        <Link to="/contact" className="btn btn-primary">Get in touch</Link>
      </div>
    </div>
  );
}
